import React__default from 'react';
import { OpenEndedDashboardItem, ChartDashboardItem } from '@sm/question-ui/aggregate-response-dashboard';
import { d as declareVisualization, p as providerFactory } from './utils-6da50e2f.js';
import { isOneDimensionalAggregateResponse, isTwoDimensionalAggregateResponse } from '@sm/question-definitions';
export { S as SingleQuestionController } from './controllers-bba08bca.js';
import './vendor-4c16529b.js';
import '@sm/question-ui/helpers';

const OpenEndedVisualization = ({
  // capability,
  // upstreamActions,
  question,
  displayOptions = {},
  settings,
  // toExternalQuestion,
  namedSlots
}) => {
  const {
    dashboardType,
    responseData,
    filterCount,
    skippedCount,
    answeredCount,
    selectedCount,
    title
  } = question;
  const {
    height,
    width
  } = displayOptions;
  return React__default.createElement(OpenEndedDashboardItem, { ...{
      dashboardType,
      height,
      width,
      title,
      filterCount,
      skippedCount,
      selectedCount,
      answeredCount
    },
    addon: namedSlots === null || namedSlots === void 0 ? void 0 : namedSlots.menu,
    responses: responseData || [],
    surveyName: settings.surveyName
  });
};

var OpenEndedVisualization$1 = declareVisualization(['single_textbox', 'comment_box'], ['aggregate-response-dashboard'], OpenEndedVisualization);

const sortCellToLabelOrder = (labelsArray, dataToSort) => {
  return labelsArray.map(label => dataToSort.find(data => data.rowItem.id === label));
};

const getDataByColumn = (aggregateResponse, columnID, isPercentage) => {
  const filtered = aggregateResponse.data.filter(item => item.columnItem.id === columnID);
  const sorted = aggregateResponse.rowHeader.items.map(({
    id
  }) => filtered.find(item => item.rowItem.id === id));
  return sorted.map(responseCell => {
    if (isPercentage) {
      return responseCell.percentage;
    }

    return responseCell.total;
  });
};

const mapToTwoDimensionalChartData = (data, isPercentageData) => {
  return data.columnHeader.items.map(column => {
    return {
      name: column.label,
      data: getDataByColumn(data, column.id, isPercentageData)
    };
  });
};

const transformOneDimensionalData = (sortedData, customization, isPercentageData) => {
  switch (customization.chartType) {
    case 'hbar':
    case 'vbar':
      {
        return sortedData.map(dataItem => isPercentageData ? dataItem.percentage : dataItem.total);
      }

    case 'donut':
    case 'pie':
      {
        return sortedData.map(item => ({
          name: item.rowItem.label,
          value: item.percentage,
          numberOfResponses: item.total
        }));
      }

    case 'line':
    case 'area':
      {
        return [{
          name: '',
          data: sortedData.map(dataItem => isPercentageData ? dataItem.percentage : dataItem.total)
        }];
      }

    case 'stacked_hbar':
    case 'stacked_vbar':
      {
        return sortedData.map(dataItem => ({
          name: dataItem.rowItem.label,
          data: [isPercentageData ? dataItem.percentage : dataItem.total]
        }));
      }

    default:
      {
        return null;
      }
  }
};

const transformToChartData = (data, customization) => {
  if (!data.data || data.data.length === 0) {
    return null; // No matching responses
  }

  const rowLabelIDs = data.rowHeader.items.map(({
    id
  }) => id);
  const isPercentageData = customization.axisScale === 'Percentage';
  const chartTypesWith2DSupport = ['hbar', 'vbar', 'line', 'area', 'stacked_hbar', 'stacked_vbar'];

  if (isOneDimensionalAggregateResponse(data)) {
    const sortedData = sortCellToLabelOrder(rowLabelIDs, data.data);
    return transformOneDimensionalData(sortedData, customization, isPercentageData);
  }

  if (chartTypesWith2DSupport.includes(customization.chartType) && isTwoDimensionalAggregateResponse(data)) {
    return mapToTwoDimensionalChartData(data, isPercentageData);
  } // eslint-disable-next-line no-console


  console.error('Incorrect chart data or customization');
  return null;
};

const ChartVisualization = ({
  // capability,
  // upstreamActions,
  question,
  displayOptions = {},
  settings,
  // toExternalQuestion,
  namedSlots
}) => {
  const {
    filterCount,
    skippedCount,
    selectedCount,
    title,
    aggregateResponse,
    answeredCount
  } = question;

  if (!aggregateResponse || !(displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.customization)) {
    // eslint-disable-next-line no-console
    console.error('Aggregate response or customization is null or undefined');
    return null;
  }

  const {
    height,
    width,
    customization
  } = displayOptions;
  const data = transformToChartData(aggregateResponse, customization) || [];
  const chartCustomization = { ...customization,
    labels: aggregateResponse.rowHeader.items.map(item => item.label)
  };
  return React__default.createElement(ChartDashboardItem, { ...{
      height,
      width,
      filterCount,
      skippedCount,
      selectedCount,
      title,
      data,
      customization: chartCustomization,
      answeredCount
    },
    addon: namedSlots === null || namedSlots === void 0 ? void 0 : namedSlots.menu,
    surveyName: settings.surveyName
  });
};

var ChartVisualization$1 = declareVisualization(['check_box', 'image_choice', 'multiple_choice', 'matrix', 'dropdown', 'slider', 'star_rating', 'ranking'], ['aggregate-response-dashboard'], ChartVisualization);
var visualizationList = [OpenEndedVisualization$1, ChartVisualization$1];
const ProviderHelper = providerFactory(visualizationList);

const AggregateResponseCapabilityProvider = ({
  upstreamActions,
  settings,
  children,
  renderProps
}) => {
  return React__default.createElement(ProviderHelper, {
    value: {
      capability: 'aggregate-response-dashboard',
      upstreamActions,
      renderProps,
      settings
    }
  }, children);
};

export { AggregateResponseCapabilityProvider as AggregateResponseDashboardProvider, visualizationList as AggregateResponseDashboardVisualizationList };